// Recovered compiled webpack factory 52486. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      ACTION_HEADER: function () {
        return n;
      },
      FLIGHT_HEADERS: function () {
        return f;
      },
      NEXT_ACTION_NOT_FOUND_HEADER: function () {
        return y;
      },
      NEXT_DID_POSTPONE_HEADER: function () {
        return h;
      },
      NEXT_HMR_REFRESH_HASH_COOKIE: function () {
        return l;
      },
      NEXT_HMR_REFRESH_HEADER: function () {
        return s;
      },
      NEXT_IS_PRERENDER_HEADER: function () {
        return g;
      },
      NEXT_REWRITTEN_PATH_HEADER: function () {
        return _;
      },
      NEXT_REWRITTEN_QUERY_HEADER: function () {
        return m;
      },
      NEXT_ROUTER_PREFETCH_HEADER: function () {
        return o;
      },
      NEXT_ROUTER_SEGMENT_PREFETCH_HEADER: function () {
        return i;
      },
      NEXT_ROUTER_STALE_TIME_HEADER: function () {
        return p;
      },
      NEXT_ROUTER_STATE_TREE_HEADER: function () {
        return a;
      },
      NEXT_RSC_UNION_QUERY: function () {
        return d;
      },
      NEXT_URL: function () {
        return u;
      },
      RSC_CONTENT_TYPE_HEADER: function () {
        return c;
      },
      RSC_HEADER: function () {
        return r;
      },
    }));
  let r = "rsc",
    n = "next-action",
    a = "next-router-state-tree",
    o = "next-router-prefetch",
    i = "next-router-segment-prefetch",
    s = "next-hmr-refresh",
    l = "__next_hmr_refresh_hash__",
    u = "next-url",
    c = "text/x-component",
    f = [r, a, o, s, i],
    d = "_rsc",
    p = "x-nextjs-stale-time",
    h = "x-nextjs-postponed",
    _ = "x-nextjs-rewritten-path",
    m = "x-nextjs-rewritten-query",
    g = "x-nextjs-prerender",
    y = "x-nextjs-action-not-found";
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
